var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.834914 13.4163C2.79659 11.4569 4.76721 9.48404 6.74231 7.51118C4.7605 5.52938 2.78764 3.55652 0.82373 1.5926C1.35609 1.06024 1.87726 0.539069 2.39397 0.022368C4.35117 1.97957 6.32403 3.95243 8.30136 5.92976C10.2944 3.93677 12.2672 1.96391 14.2289 0C14.7635 0.534596 15.2847 1.05577 15.7991 1.57024C13.8419 3.52744 11.8691 5.5003 9.89397 7.4754C11.887 9.46839 13.8598 11.4412 15.8237 13.4052C15.2891 13.9398 14.768 14.4609 14.2535 14.9754C12.2963 13.0182 10.3234 11.0453 8.34834 9.07024C6.35534 11.0632 4.38248 13.0361 2.41857 15C1.88398 14.4654 1.3628 13.9465 0.834914 13.4163Z","fill":"white"}));
}

Close.defaultProps = {"width":"16","height":"15","viewBox":"0 0 16 15","fill":"none"};

module.exports = Close;

Close.default = Close;
